module.exports = __webpack_public_path__ + "media/images/steps/step_20-fa666472a3568b91547f66ded2f11129.svg";